// extracted by mini-css-extract-plugin
module.exports = {"plusMinusIcon":"plusminus_plusMinusIcon__i5HwD","p2":"plusminus_p2__P_5J5","plusMinusIcon--minus":"plusminus_plusMinusIcon--minus__vQtND"};